<p *ngIf="text !== null" class="label" [className]="'label ' + class">
  {{ text | translate }}
</p>
<p *ngIf="text === null" class="label label-default">No status</p>
